import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Info as InfoIcon 
} from '@mui/icons-material';

const CustomNode = ({ data, isConnectable, selected }) => {
  const IconComponent = data.icon;

  return (
    <Box
      sx={{
        padding: '10px 15px',
        borderRadius: '8px',
        background: selected ? 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)' : '#ffffff',
        border: selected ? '2px solid #1976d2' : '1px solid #ddd',
        boxShadow: selected ? '0 4px 20px rgba(33, 150, 243, 0.3)' : '0 2px 10px rgba(0,0,0,0.1)',
        minWidth: '150px',
        position: 'relative',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        style={{
          background: '#555',
          width: 8,
          height: 8,
          border: '2px solid #fff'
        }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {IconComponent && (
          <IconComponent 
            sx={{ 
              fontSize: 20, 
              color: selected ? '#fff' : '#666' 
            }} 
          />
        )}
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 500,
            color: selected ? '#fff' : '#333',
            flexGrow: 1
          }}
        >
          {data.label}
        </Typography>
      </Box>
      
      {data.description && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: selected ? 'rgba(255,255,255,0.8)' : '#666',
            display: 'block',
            mt: 0.5,
            fontSize: '0.7rem'
          }}
        >
          {data.description}
        </Typography>
      )}

      {/* Action buttons - only show on hover */}
      <Box
        sx={{
          position: 'absolute',
          top: -8,
          right: -8,
          display: 'flex',
          gap: 0.5,
          opacity: selected ? 1 : 0,
          transition: 'opacity 0.2s ease'
        }}
      >
        {data.description && (
          <Tooltip title={data.description}>
            <IconButton 
              size="small" 
              sx={{ 
                backgroundColor: '#2196F3', 
                color: 'white',
                width: 20,
                height: 20,
                '&:hover': { backgroundColor: '#1976D2' }
              }}
            >
              <InfoIcon sx={{ fontSize: 12 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        style={{
          background: '#555',
          width: 8,
          height: 8,
          border: '2px solid #fff'
        }}
      />
    </Box>
  );
};

export default memo(CustomNode);